import React, { useState } from 'react';
import '../styles/Sidebar.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import logo from '../assets/logo.png';

const menuItems = [

  {
    id: 'Dashboard',
    name: 'Dashboard',
    icon: 'bi-speedometer2'
  },

    {
    id: 'Master',
    name: 'Master',
    icon: 'bi-database',
    hasChildren: true,
    children: [
      { id: 'Product', name: 'Product', icon: 'bi-box-seam' },
      // { id: 'Ledgers', name: 'Ledgers', icon: 'bi-people' },

      { id: 'Banks', name: 'Banks', icon: 'bi-bank' },
    ]
  },

  {
    id: 'Pump ',
    name: 'Pump Configration',
    icon: 'bi-fuel-pump',
    hasChildren: true,
    children: [
      { id: 'Tank', name: 'Tank', icon: 'bi-gear' },
      { id: 'PumpList', name: 'Pump List', icon: 'bi-list-ul' },
      { id: 'NozzleConfig', name: 'Nozzle Config', icon: 'bi-sliders' },
    ]
  },



  {
    id: 'Entry',
    name: 'Readings',
    icon: 'bi-pencil-square',
    hasChildren: true,
    children: [
      { id: 'OpeningStock', name: 'Readings', icon: 'bi-pencil-square' },
      // { id: 'ClosingStock', name: 'Closing Reading', icon: 'bi-box-arrow-up' },
      { id: 'MeterReading', name: 'Meter Reading', icon: 'bi-speedometer' },
    ]
  },

  {
    id: 'Sale',
    name: 'Sales',
    icon: 'bi-cash-stack',
    hasChildren: true,
    children: [
      { id: 'Customer', name: 'Customers', icon: 'bi-people' },
      { id: 'SaleList', name: 'Sale List', icon: 'bi-receipt' },
     
      { id: 'BillReceipt', name: 'Bill Receipt', icon: 'bi-receipt-cutoff' },
    ]
  },

  
  {
    id: 'Purchase',
    name: 'Purchase',
    icon: 'bi-cart',
    hasChildren: true,
    children: [

      { id: 'PurchaseEntry', name: 'Purchase Entry', icon: 'bi-bag-check' },
      { id: 'Payments', name: 'Payments', icon: 'bi-cash-coin' },
    ]
  },

  // {
  //   id: 'Dip',
  //   name: 'Dip',
  //   icon: 'bi-rulers',
  //   hasChildren: true,
  //   children: [
  //     { id: 'DipReading', name: 'Dip Reading', icon: 'bi-bar-chart' },
  //     { id: 'DipChart', name: 'Dip Chart', icon: 'bi-bar-chart-line' },
  //   ]
  // },

];

export default function Sidebar({ activePage, setActivePage }) {

  const [collapsed, setCollapsed] = useState(false);
  const [openMenus, setOpenMenus] = useState({});

  const toggleMenu = (id) => {
    setOpenMenus((prev) => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const handleClick = (item) => {
    if (item.hasChildren) {
      toggleMenu(item.id);
    } else {
      setActivePage(item.id);
    }
  };

  return (

    <div className={`sidebar ${collapsed ? 'collapsed' : ''}`}>

      <div
        className="sidebar-logo"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 10,
          position: 'relative',
          padding: '20px 10px',
          minHeight: '80px'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'center' }}>
          <img
            src={logo}
            alt="Noris Logo"
            style={{
              width: 36,
              height: 36,
              objectFit: 'cover',
              borderRadius: '50%',
              border: '2px solid rgba(255, 255, 255, 0.15)',
              backgroundColor: 'white',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
            }}
          />

          {!collapsed && (
            <span
              className="logo-text"
              style={{
                fontWeight: 700,
                fontSize: '18px',
                letterSpacing: '0.5px',
                color: '#fff'
              }}
            >
              Noris
            </span>
          )}
        </div>

        <button
          className="collapse-btn"
          onClick={() => setCollapsed(!collapsed)}
          style={{
            position: 'absolute',
            right: '8px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'rgba(255,255,255,0.1)',
            borderRadius: '4px',
            width: '24px',
            height: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: 'none',
            color: '#fff',
            cursor: 'pointer'
          }}
        >
          <i className={`bi ${collapsed ? 'bi-chevron-right' : 'bi-chevron-left'}`}></i>
        </button>
      </div>

      <nav className="sidebar-nav">

        {menuItems.map((item) => (

          <div key={item.id}>

            <div
              className={`sidebar-item ${activePage === item.id ? 'active' : ''}`}
              onClick={() => handleClick(item)}
            >

              <span className="item-icon">
                <i className={`bi ${item.icon}`}></i>
              </span>

              {!collapsed && (
                <>
                  <span className="item-name">
                    {item.name}
                  </span>

                  {item.hasChildren && (
                    <span
                      className="arrow"
                      style={{
                        transform: openMenus[item.id]
                          ? 'rotate(90deg)'
                          : 'rotate(0deg)'
                      }}
                    >
                      <i className="bi bi-chevron-right"></i>
                    </span>
                  )}
                </>
              )}

            </div>

            {!collapsed && item.hasChildren && openMenus[item.id] && (

              <div className="sidebar-submenu">

                {item.children.map((child) => (

                  <div
                    key={child.id}
                    className={`sidebar-item ${activePage === child.id ? 'active' : ''}`}
                    onClick={() => setActivePage(child.id)}
                  >

                    <span className="item-icon">
                      <i className={`bi ${child.icon}`}></i>
                    </span>

                    <span className="item-name">
                      {child.name}
                    </span>

                  </div>

                ))}

              </div>

            )}

          </div>

        ))}

      </nav>

      

    </div>

  );

}